import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { IconModule } from '@ui-components/components/icon/icon.module';

import { UnitDetailsInspectionsComponent } from './unit-details-inspections.component';

@NgModule({
  declarations: [UnitDetailsInspectionsComponent],
  imports: [
    CommonModule,
    IconModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatTableModule,
    MatDividerModule,
    MatMenuModule,
  ],
  exports: [UnitDetailsInspectionsComponent],
})
export class UnitDetailsInspectionsModule {}
